import { t } from '~/i18n';

export type GraphSize = 'full' | 'half';
export type GraphUnit = 'count' | 'duration';

/** One graph on an analytics tab. Position follows the list order and size is fixed for now;
 *  both are plain data so a user-arranged dashboard can later be stored as a list of these. */
export type GraphDefinition = {
  id: string;
  /** Backend query family; the bucket suffix (`.5m`, `.1d`, `.1mo`) is picked from the window. */
  family: string;
  /** Bars stack their series, so use them for sums; lines overlay them. */
  chart: 'bar' | 'line';
  size: GraphSize;
  /** `duration` values are seconds. */
  unit: GraphUnit;
  title: () => string;
  /** Labels for the query's series, keyed by the backend's series name. A query without series
   *  has a single unnamed one, labelled by `valueLabel`. */
  seriesLabels?: Record<string, () => string>;
  valueLabel?: () => string;
};

const untilAction = (action: string) => () => t('statistics.untilAction', { action: t(action) });

export const ALERTS_GRAPHS: GraphDefinition[] = [
  {
    id: 'alerts.count',
    family: 'alerts.count',
    chart: 'bar',
    size: 'full',
    unit: 'count',
    title: () => t('statistics.alarmCount'),
    valueLabel: () => t('menu.dashboard.alerts'),
  },
  {
    id: 'alerts.responseTime',
    family: 'alerts.response_seconds',
    chart: 'line',
    size: 'full',
    unit: 'duration',
    title: () => t('statistics.alarmResponseTimes'),
    seriesLabels: {
      accept: untilAction('alert.actions.accept'),
      resolve: untilAction('alert.actions.resolve'),
    },
  },
];
